export default __webpack_public_path__ + "static/media/CWS_Weihnachtskarte_Workwear.92c647ba.png";